export const BASE_URL = "https://api.farmer360.in/api/v1/";
export const STATIC_BASE_URL = "https://api.farmer360.in/";

export const SUPER_ADMIN_LOGIN = "super-admin/login";

//Admin
export const CREATE_TENANT_USER = "tenant/create"; 
export const GET_ALL_TENANT_USER = "tenant/super-admin/:superAdminId";
export const GET_TENANT_USER_BY_ID = "tenant/:id";
export const UPDATE_TENANT = "tenant/:id";

//Users
export const GET_ALL_TENANTS = "tenant/all";
export const CREATE_USER = "tenant-user";
export const GET_ALL_USERS = "tenant-user";
export const GET_USER_BY_ID = "tenant-user/:userId";
export const UPDATE_TENANT_USER = "tenant-user/:userId"; 
export const UPDATE_TENANT_USER_STATUS = "tenant-user/:userId/status";
export const UPDATE_TENANT_USER_PASSWORD = "tenant-user/:userId/password";

export const CREATE_CROP ="crop";
export const GET_BY_ID_CROP ="crop/:cropId";
export const GET_ALL_CROPS ="crop";
export const UPDATE_CROP ="crop/:cropId";

export const CREATE_VARIETY ="variety";
export const GET_BY_ID_VARIETY ="variety/:varietyId";
export const GET_ALL_VARIETIES ="variety";
export const UPDATE_VARIETY ="variety/:varietyId";

export const TENANT_LOGIN = "tenant-user/login";

export const CREATE_ZONE = "zone";
export const GET_ALL_ZONES = "zone";
export const GET_ZONE_BY_ID = "zone/:zoneId";
export const UPDATE_ZONE = "zone/:zoneId";

export const CREATE_REGION = "region";
export const GET_ALL_REGIONS = "region";
export const GET_REGION_BY_ID = "region/:regionId";
export const UPDATE_REGION = "region/:regionId";

export const CREATE_AREA = "area";
export const GET_ALL_AREAS = "area";
export const GET_AREA_BY_ID = "area/:areaId";
export const UPDATE_AREA = "area/:areaId";

export const CREATE_DISTRICT = "geography/district";
export const GET_ALL_DISTRICTS = "geography/district";
export const GET_DISTRICT_BY_ID = "geography/district/:districtId";
export const UPDATE_DISTRICT = "geography/district/:districtId";

export const CREATE_MANDAL = "geography/mandal";
export const GET_ALL_MANDALS = "geography/mandal";
export const GET_MANDAL_BY_ID = "geography/mandal/:mandalId";
export const UPDATE_MANDAL = "geography/mandal/:mandalId";

export const CREATE_VILLAGE = "geography/village";
export const GET_ALL_VILLAGES = "geography/village";
export const GET_VILLAGE_BY_ID = "geography/village/:villageId";
export const UPDATE_VILLAGE = "geography/village/:villageId";

export const CREATE_DEALER = "dealer";
export const GET_ALL_DEALERS = "dealer";
export const GET_DEALER_BY_ID = "dealer/:dealerId";
export const UPDATE_DEALER = "dealer/:dealerId";

export const CREATE_FARMER ="farmer";
export const GET_ALL_FARMERS ="farmer";
export const GET_FARMER_BY_ID ="farmer/:farmerId";
export const UPDATE_FARMER ="farmer/:farmerId";

export const GET_SEASONS ="season";
export const GET_SEASON_BY_ID ="season/:seasonId";
export const CREATE_SEASON ="season";
export const UPDATE_SEASON ="season/:seasonId";

export const GET_SALES_TARGETS ="target/sales";
export const GET_SALES_TARGET_BY_ID ="target/sales/:id";
export const CREATE_SALES_TARGET ="target/sales";
export const UPDATE_SALES_TARGET ="target/sales/:id";

export const CREATE_PRE_SEASON_ACTIVITY = "target/pre-season";
export const GET_ALL_PRE_SEASON_ACTIVITIES = "target/pre-season";
export const GET_PRE_SEASON_ACTIVITY_BY_ID = "target/pre-season/:id";
export const UPDATE_PRE_SEASON_ACTIVITY = "target/pre-season/:id";

export const CREATE_POST_SEASON_ACTIVITY = "target/post-season";
export const GET_ALL_POST_SEASON_ACTIVITIES = "target/post-season";
export const GET_POST_SEASON_ACTIVITY_BY_ID = "target/post-season/:id";
export const UPDATE_POST_SEASON_ACTIVITY = "target/post-season/:id";

export const CREATE_FARMER_COMMITMENT = 'farmer';
export const FARMER_COMMITMENT = 'farmer-commitment';
export const GET_ALL_FARMER_COMMITMENTS = 'farmer-commitment';
export const GET_FARMER_COMMITMENT_BY_ID = 'farmer-commitment/:farmerId';
export const UPDATE_FARMER_COMMITMENT = 'farmer-commitment/:farmerId';

export const CREATE_MONTHLY_TARGET = 'target/pre-activity-details/bulk';
export const GET_ALL_MONTHLY_TARGETS = 'target/pre-activity-details';

export const CREATE_ACTIVITY = 'activity/pre';
export const GET_ALL_ACTIVITIES = 'activity/pre';
export const GET_ACTIVITY_BY_ID = 'activity/pre/:id';
export const UPDATE_ACTIVITY = 'activity/pre/:id';

export const CREATE_POST_MONTHLY_TARGET = 'target/post-activity-details';
export const GET_ALL_POST_MONTHLY_TARGETS = 'target/post-activity-details';

export const CREATE_POST_ACTIVITY = 'activity/post';
export const GET_ALL_POST_ACTIVITIES = 'activity/post';
export const GET_POST_ACTIVITY_BY_ID = 'activity/post/:id';
export const UPDATE_POST_ACTIVITY = 'activity/post/:id';

export const GET_MEDIA_FILES = 'activity-media/pre';
export const GET_POST_MEDIA_FILES = 'activity-media/post';

export const CREATE_DAILY_PUNCH = 'employee-daily-travel';
export const GET_DAILY_PUNCHES = 'employee-daily-travel';
export const UPDATE_DAILY_PUNCH = 'employee-daily-travel/:travelId';
export const GET_DAILY_PUNCH_BY_ID = 'employee-daily-travel/:travelId';

export const CREATE_DAILY_TASK = 'daily-task';
export const GET_DAILY_TASKS = 'daily-task';
export const UPDATE_DAILY_TASK = 'daily-task/:taskId';
export const GET_DAILY_TASK_BY_ID = 'daily-task/:taskId';

export const LOGIN_WITH_OTP = 'tenant-user/login/otp';
export const VERIFY_LOGIN_OTP = 'tenant-user/login/otp/verify';
export const FORGOT_PASSWORD = 'tenant-user/forgot-password/otp';
export const VERIFY_FORGOT_PASSWORD = 'tenant-user/forgot-password/otp/verify';

export const CALCULATE_SALES_TARGET = 'target/sales/calc-expected-acre';